function attributionTagging() {
  // When adding product, add line item property if customer is tagged
  let attribution = JSON.parse(localStorage.getItem('attribution'));
  let attributionPageDate = localStorage.getItem('attribution_date');
  let forms = document.querySelectorAll('form[action*="/cart/add"]');
  
  forms.forEach((form) => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = `properties[_attribution]`;
    input.value = attribution;
    form.appendChild(input);
  });
  if (attributionPageDate) {
    forms.forEach((form) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[_attribution_date]';
      input.value = attributionPageDate;
      form.appendChild(input);
    });
  } else {
    console.log('No attribution data found');
  }
}
attributionTagging();